import { Button, Checkbox, Grid } from '@mui/material';
import _ from 'lodash';
import React, { } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Utility from '../../../../app/utility';
import EmailEditorButton from '../../../EmailEditorModal/EmailEditorButton';
import EmailEditorModel from '../../../EmailEditorModal/models/EmailEditorModel';
import StartEndDatepicker from '../../../StartEndDatepicker/StartEndDatepicker';
import { SupportSheetHelpTextConstant } from '../../models/SupportSheetHelperTextConstant';
import { SupportSheetSelector, setCurrentHire, setCurrentHireIndex, setShowEditHireIndex } from '../../reducers/SupportSheetReducer';
import { setEmailSendAfterAgree, setHelperText, setShowEmailAfterOk, setShowHelperTextModal, setTitle } from '../SupportSheetHelpText/reducers/SupportSheetHelpTextReducer';
import SupportSheetHirePaymentStatusModel from './models/SupportSheetHidePaymentStatusModel';
import { PopupEmail } from '../../SupportSheetPreVoyage';
import { contructEmailSubjectPrefix } from '../../SupportSheetBiefInformation';
import SupportSheetEditHireIndexModal from './SupportSheetEditHireIndexModal';

interface SupportSheetHirePaymentStatusProp {
    items: SupportSheetHirePaymentStatusModel[],
    disabled?: boolean,
    className?: string,
    errorClassName?: string,
    onChange?: (selectedItem: SupportSheetHirePaymentStatusModel[]) => void,
}

export const getDefaultHidePaymentStatus = () => {
    return [{
        index: 0,
        from: "",
        to: "",
        askOwnerForInvoice: false,
        sendToChtrs: false,
        sendBankSlip: false,
        isFinalHire: false
    } as SupportSheetHirePaymentStatusModel,
    {
        index: 1,
        from: "",
        to: "",
        askOwnerForInvoice: false,
        sendToChtrs: false,
        sendBankSlip: false,
        isFinalHire: false
    } as SupportSheetHirePaymentStatusModel,
    {
        index: 2,
        from: "",
        to: "",
        askOwnerForInvoice: false,
        sendToChtrs: false,
        sendBankSlip: false,
        isFinalHire: false
    } as SupportSheetHirePaymentStatusModel];
}

const SupportSheetHirePaymentStatus: React.FunctionComponent<SupportSheetHirePaymentStatusProp> = (props) => {
    const dispatch = useDispatch();
    const supportSheetData = useSelector(SupportSheetSelector);

    let ordinal_suffix_of = (i: number) => {
        var j = i % 10,
            k = i % 100;
        if (j == 1 && k != 11) {
            return i + "st";
        }
        if (j == 2 && k != 12) {
            return i + "nd";
        }
        if (j == 3 && k != 13) {
            return i + "rd";
        }
        return i + "th";
    }


    return (
        <div className={props.errorClassName}>
            <Grid container>
                <Grid item xs={6}>
                    <b>Hire payments status</b>
                </Grid>
                <Grid item xs={5}>
                    <Grid container>
                        <Grid item xs={4}>
                            <b>Ask Owners for invoice</b>
                        </Grid>
                        <Grid item xs={4}>
                            <b>Send to Chtrs</b>
                        </Grid>
                        <Grid item xs={4}>
                            <b>Send bank slip</b>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                </Grid>
            </Grid>
            {
                props.items.map((item: SupportSheetHirePaymentStatusModel, index: number) => (
                    <>
                        <Grid container>
                            <Grid item xs={6}>
                                <Grid container>
                                    <Grid item xs={2}>
                                        {
                                            item.isFinalHire &&
                                            <>Final Hire</>
                                        }
                                        {
                                            !item.isFinalHire &&
                                            <span
                                                className='hire-payment-edit'
                                                onClick={() => {
                                                    dispatch(setCurrentHire(item));
                                                    dispatch(setShowEditHireIndex(true));
                                                    dispatch(setCurrentHireIndex(index));
                                                }}
                                            >
                                                {ordinal_suffix_of(item.index + 1)} Hire
                                            </span>
                                        }
                                    </Grid>
                                    <Grid item xs={5}>
                                        <StartEndDatepicker
                                            startDateLabel="From"
                                            className="cargo-input-component"
                                            useSingleMode={true}
                                            disabled={props.disabled}
                                            useQuickEndDateInput={false}
                                            onStartDateChange={(date: string) => {
                                                if (props.onChange) {
                                                    props.items[index].from = date;
                                                    props.onChange(props.items);
                                                }
                                            }}
                                            startDateValue={item.from.toUpperCase()}
                                            allowFreeInput={true}
                                            hideDateSelector={true}
                                            customFormatDate={(date: Date) => {
                                                return Utility.DateFormat.formatDDMMMYYhhss(date).toUpperCase();
                                            }}
                                        >
                                        </StartEndDatepicker>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <StartEndDatepicker
                                            startDateLabel="To"
                                            className="cargo-input-component"
                                            useSingleMode={true}
                                            disabled={props.disabled}
                                            useQuickEndDateInput={false}
                                            onStartDateChange={(date: string) => {
                                                if (props.onChange) {
                                                    props.items[index].to = date;
                                                    props.onChange(props.items);
                                                }
                                            }}
                                            startDateValue={item.to.toUpperCase()}
                                            allowFreeInput={true}
                                            hideDateSelector={true}
                                            customFormatDate={(date: Date) => {
                                                return Utility.DateFormat.formatDDMMMYYhhss(date).toUpperCase();
                                            }}
                                        >
                                        </StartEndDatepicker>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={5}>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Checkbox
                                            checked={item.askOwnerForInvoice}
                                            disabled={props.disabled}
                                            onChange={(event) => {
                                                if (props.onChange) {
                                                    props.items[index].askOwnerForInvoice = event.target.checked;
                                                    props.onChange(props.items);
                                                }
                                            }}
                                        />
                                        <EmailEditorButton
                                            disable={props.disabled}
                                            onClick={() => {
                                                if (props.disabled) {
                                                    return;
                                                }

                                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                                    PopupEmail({
                                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + ((item.isFinalHire ? "Final" : ordinal_suffix_of(index + 1)) + " Hire payment").toUpperCase(),
                                                        emailContent: `Please kindly send us Owners' ${(item.isFinalHire ? "final" : ordinal_suffix_of(index + 1))} hire payment for Chtrs arrangement.`,
                                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                                } else {
                                                    Utility.Alert.Error("Please select owner principle before sending email");
                                                }
                                            }}
                                        ></EmailEditorButton>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Checkbox
                                            checked={item.sendToChtrs}
                                            disabled={props.disabled}
                                            onChange={(event) => {
                                                if (props.onChange) {
                                                    props.items[index].sendToChtrs = event.target.checked;
                                                    props.onChange(props.items);
                                                }
                                            }}
                                        />
                                        <EmailEditorButton
                                            disable={props.disabled}
                                            onClick={() => {
                                                if (props.disabled) {
                                                    return;
                                                }

                                                if (supportSheetData.chartererBrokerContactPrinciple) {
                                                    let emailToSend = {
                                                        emailTo: supportSheetData.chartererBrokerContactPrinciple?.emailTo,
                                                        emailCc: supportSheetData.chartererBrokerContactPrinciple?.emailCc,
                                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + ((item.isFinalHire ? "Final" : ordinal_suffix_of(index + 1)) + "Hire payment").toUpperCase(),
                                                        emailContent: `Please find in attachment here with our ${(item.isFinalHire ? "final" : ordinal_suffix_of(index + 1))} hire invoice for your kind arrangement.\nWe suggest you insert invoice number ONLY and DO NOT mention the vessel's name in payment details enabling to avoid unnecessary problem with bank.\nViewing recent high risk from Cyber-crime, please verify with me via methods other than emails (i.e. phone call, WhatsApp, Skype,…) about Owners Beneficiary account details before process remittance (especially if Beneficiary name/address are different from our C/P). Thank you.`,
                                                        receivedName: supportSheetData.chartererBrokerContactPrinciple?.pic

                                                    } as EmailEditorModel;

                                                    dispatch(setTitle("Send to charterers"));
                                                    dispatch(setHelperText(SupportSheetHelpTextConstant["Please remember to verify bank account"]));
                                                    dispatch(setEmailSendAfterAgree(emailToSend));
                                                    dispatch(setShowEmailAfterOk(true));
                                                    dispatch(setShowHelperTextModal(true));
                                                } else {
                                                    Utility.Alert.Error("Please select owner principle before sending email");
                                                }

                                            }}
                                        ></EmailEditorButton>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Checkbox
                                            checked={item.sendBankSlip}
                                            disabled={props.disabled}
                                            onChange={(event) => {
                                                if (props.onChange) {
                                                    props.items[index].sendBankSlip = event.target.checked;
                                                    props.onChange(props.items);
                                                }
                                            }}
                                        />
                                        <EmailEditorButton
                                            disable={props.disabled}
                                            onClick={() => {
                                                if (props.disabled) {
                                                    return;
                                                }

                                                if (supportSheetData.ownerBrokerContactPrinciple) {
                                                    PopupEmail({
                                                        emailTo: supportSheetData.ownerBrokerContactPrinciple?.emailTo,
                                                        emailCc: supportSheetData.ownerBrokerContactPrinciple?.emailCc,
                                                        emailSubject: contructEmailSubjectPrefix(supportSheetData) + ((item.isFinalHire ? "Final" : ordinal_suffix_of(index + 1)) + " Hire payment").toUpperCase(),
                                                        emailContent: `Attached bank slip for ${(item.isFinalHire ? "final" : ordinal_suffix_of(index + 1))} hire payment for Owners checking.\n\nPlease kindly confirm once receive payment. Thank you.`,
                                                        receivedName: supportSheetData.ownerBrokerContactPrinciple?.pic
                                                    } as EmailEditorModel, supportSheetData.brokerEmails);
                                                } else {
                                                    Utility.Alert.Error("Please select owner principle before sending email");
                                                }
                                            }}
                                        ></EmailEditorButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={1}>
                                <Button
                                    className='table-action-button'
                                    disabled={props.disabled}
                                    onClick={() => {
                                        if (props.disabled) {
                                            return;
                                        }

                                        if (props.onChange) {
                                            props.items.splice(index, 1);
                                            props.onChange(props.items);
                                        }
                                    }}
                                    variant='text'
                                >
                                    <i className="fa fa-times" aria-hidden="true"></i>
                                </Button>
                            </Grid>
                        </Grid>
                    </>
                ))
            }
            <Button
                color="secondary"
                variant='outlined'
                disabled={props.disabled}
                onClick={() => {
                    if (props.disabled) {
                        return;
                    }

                    let newItem = {
                        index: props.items[props.items.length - 1].index + 1,
                        from: "",
                        to: "",
                        askOwnerForInvoice: false,
                        sendToChtrs: false
                    } as SupportSheetHirePaymentStatusModel;

                    props.items.push(newItem);

                    if (props.onChange) {
                        props.onChange(props.items);
                    }
                }}
            >Add More Hire</Button>
            <Button
                color="secondary"
                variant='outlined'
                disabled={props.disabled}
                onClick={() => {
                    if (props.disabled) {
                        return;
                    }

                    let newItem = {
                        index: props.items.length,
                        from: "",
                        to: "",
                        askOwnerForInvoice: false,
                        sendToChtrs: false,
                        isFinalHire: true
                    } as SupportSheetHirePaymentStatusModel;

                    props.items.push(newItem);

                    if (props.onChange) {
                        props.onChange(props.items);
                    }
                }}
            >Add Final Hire</Button>
            <SupportSheetEditHireIndexModal>
            </SupportSheetEditHireIndexModal>
        </div>
    )
};

export default SupportSheetHirePaymentStatus;